import {
    DeviceConsumptionType,
    SharedDeviceInput,
    VirtualDeviceInput,
    VirtualDeviceInputFillup,
} from 'types';

export const calculateFillsUps = (
    device: VirtualDeviceInput
): VirtualDeviceInputFillup[] => {
    return device.fillups.map(
        (fillup: VirtualDeviceInput['fillups'][number]) => {
            const diff = fillup.amount / device.capacity;

            return {
                ...fillup,
                capacity: device.capacity,
                partial: 'false',
                diff,
                after: 0.8 * device.capacity,
                before: (0.8 - diff) * device.capacity,
            };
        }
    );
};

export const mapConsumptionTypes = (
    device: SharedDeviceInput
): DeviceConsumptionType => {
    const consumptionType: DeviceConsumptionType = {
        bulk_storage: false,
        commercial_industrial: false,
        cooking: false,
        fireplace: false,
        generator: false,
        heating: false,
        hot_water: false,
        laundry_dryer: false,
        pool: false,
        retail_fill_up: false,
        backup_heating: false,
    };

    for (const type of device.consumptionType) {
        consumptionType[type] = true;
    }

    return consumptionType;
};
